module.exports = __webpack_public_path__ + "static/media/FORMATO CERTIFICADO DE TOTAL DE INGRESOS ANUALES.db45348c.pdf";